import { type TDataTableColumn } from './types'

export const toGridTemplateColumn = <T extends Record<string, unknown> | unknown[]>(
  column: TDataTableColumn<T>
): string => {
  if (column.grow) {
    const minWidth = column.width ? `${column.width}px` : 'max-content'
    return `minmax(${minWidth}, 1fr)`
  }

  if (column.width && column.maxWidth) {
    const maxWidth = Math.max(column.width, column.maxWidth)
    return `minmax(${column.width}px, ${maxWidth}px)`
  }

  if (column.width) return `${column.width}px`
  return 'max-content'
}
